import BigNumber from 'bignumber.js';
import { zero } from 'constants/zero';
import { CreateMasterReservePayloadDto } from 'libs/pinnacle-sdk';
import { fields } from './form';
import { MasterReserveResponseDto } from 'libs/pinnacle-sdk';

export const calculateTotalIncurredCosts = (params: {
  lossAdjustorCosts?: BigNumber;
  legalExpertsCosts?: BigNumber;
  consultantsCosts?: BigNumber;
  otherFees?: BigNumber;
}): BigNumber => {
  const { lossAdjustorCosts, legalExpertsCosts, consultantsCosts, otherFees } =
    params;

  return BigNumber.sum(
    lossAdjustorCosts || zero,
    legalExpertsCosts || zero,
    consultantsCosts || zero,
    otherFees || zero
  );
};

export const calculateTotalFguMarketLossIndemnityExcCosts = (params: {
  indemnityMaterialDamage?: BigNumber;
  indemnityBusinessInterruption?: BigNumber;
  underliningSirGovtProgramsSir?: BigNumber;
}): BigNumber => {
  const {
    indemnityMaterialDamage,
    indemnityBusinessInterruption,
    underliningSirGovtProgramsSir,
  } = params;

  return BigNumber.sum(
    indemnityMaterialDamage || zero,
    indemnityBusinessInterruption || zero
  ).minus(underliningSirGovtProgramsSir || zero);
};

export const calculateTotalFguMarketLoss = (params: {
  totalIncurredCosts: BigNumber;
  totalFguMarketLossIndemnityExcCosts: BigNumber;
}): BigNumber => {
  const { totalIncurredCosts, totalFguMarketLossIndemnityExcCosts } = params;
  return BigNumber.sum(totalIncurredCosts, totalFguMarketLossIndemnityExcCosts);
};

const numericFieldSet = new Set<keyof CreateMasterReservePayloadDto>([
  'indemnityMaterialDamage',
  'indemnityBusinessInterruption',
  'underliningSirGovtProgramsSir',
  'lossAdjustorCosts',
  'legalExpertsCosts',
  'consultantsCosts',
  'otherFees',
  'programCessionPercent',
  'captiveSirsAag',
  'riSirAag',
  'riCessionPercent',
  'projectedUltimateLoss',
  'recoveryPotential',
  'recoveryActual',
]);

export const ensureNumericValues = (
  values: Partial<CreateMasterReservePayloadDto>
): Partial<CreateMasterReservePayloadDto> =>
  fields.reduce<Partial<CreateMasterReservePayloadDto>>((acc, field) => {
    const value = values[field];

    if (numericFieldSet.has(field)) {
      return {
        ...acc,
        [field]: value === undefined || value === null ? 0 : Number(value),
      };
    }

    return { ...acc, [field]: value };
  }, {});
